import { ViewOrUpdatePaymentMethodsCTA } from "./ctas";
export var BillingAddressIA = function BillingAddressIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UPDATE_BILLING_ADDRESS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_UPDATE_PAYMENT_METHOD_BILLING_ADDRESS(strictLocalize), TO_CHANGE_ADDRESS_ON_PAID_INVOICES(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return ViewOrUpdatePaymentMethodsCTA(strictLocalize);
};
var UPDATE_BILLING_ADDRESS = function UPDATE_BILLING_ADDRESS(strictLocalize) {
  return strictLocalize({
    id: "nXI6XZ",
    defaultMessage: [{
      "type": 0,
      "value": "Atualizar endereço de faturação"
    }]
  });
};
var TO_UPDATE_PAYMENT_METHOD_BILLING_ADDRESS = function TO_UPDATE_PAYMENT_METHOD_BILLING_ADDRESS(strictLocalize) {
  return strictLocalize({
    id: "Uy9NJm",
    defaultMessage: [{
      "type": 0,
      "value": "Há um endereço de faturação associado a cada forma de pagamento guardada. Para atualizar, aceda a \"Formas de pagamento\" nas \"Definições de conta\" e encontre a forma de pagamento que pretende alterar. Selecione \"Editar\" junto do endereço de faturação e selecione um dos endereços utilizados anteriormente ou adicione um novo. Se atualizar o endereço de faturação de uma forma de pagamento, este será alterado em todas as faturas não pagas que a utilizem."
    }]
  });
};
var TO_CHANGE_ADDRESS_ON_PAID_INVOICES = function TO_CHANGE_ADDRESS_ON_PAID_INVOICES(strictLocalize) {
  return strictLocalize({
    id: "C88qQ9",
    defaultMessage: [{
      "type": 0,
      "value": "Para alterar o endereço nas faturas pagas, aceda à fatura que pretende atualizar e escolha \"Editar endereço\". Pode selecionar um dos endereços utilizados anteriormente ou adicionar um novo endereço para incluir na fatura. Se modificar faturas pagas, tem de editar cada uma individualmente. Se fizer alterações, o endereço de faturação associado à sua forma de pagamento não é afetado."
    }]
  });
};